export default __webpack_public_path__ + "static/media/jump_attack.7933ad32.gif";